<!-- .nav-item from bootstrap and scss/_nav.scss -->
<div
    class="nav-item"
    *ngFor="let c of _dialogService.state?.navCategories"
>
    <!-- .cmps-nav-icon from bootstrap and scss/_nav.scss -->
    <button
        class="cmps-icon-button--no-bg cmps-icon-button--no-bg--white cmps-nav-icon cmps-event-centre-nav-button--button"
        [class.active]="
            _dialogService.isOpen &&
            _dialogService.state?.categoryId === c.categoryId
        "
        cmpsIconButton
        tabindex="0"
        role="menuitem"
        (click)="_dialogService.open(c.categoryId)"
    >
        <div
            class="cmps-event-centre-nav-button--tooltip"
            [cmpsTooltipTrigger]="c.label | translate"
            placement="bottom-center"
            [openDelay]="1000"
        ></div>

        <div
            class="cmps-event-centre-nav-button--wrapper"
            [cmpsBadge]="c.unreadCountLabel"
            cmpsBadgePlacement="bottom-right"
            [cmpsBadgeHidden]="c.unreadCount <= 0"
            cmpsBadgeClassName="cmps-cdk-bg-color-red-100"
        >
            <cmps-icon [svgIcon]="c.icon"></cmps-icon>
        </div>

        <!-- .line from scss/_nav.scss -->
        <div class="line"></div>
    </button>
</div>
